import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../reducers";
import { bindActionCreators } from "redux";
import * as actionDataOps from '../actions/dataops';


export const useDataOpsState = () => {
  const dataOpsRedux = useSelector((state: RootState) => state.dataOps);
  return { dataOpsRedux };
};

export const useDataOpsDispatch = () => {
  const dispatch = useDispatch();
  return { ...bindActionCreators({ ...actionDataOps }, dispatch) };
};
